import { render, staticRenderFns } from "./products.import.component.vue?vue&type=template&id=2e3b67a8&scoped=true&"
import script from "./products.import.component.vue?vue&type=script&lang=js&"
export * from "./products.import.component.vue?vue&type=script&lang=js&"
import style0 from "./products.import.component.vue?vue&type=style&index=0&id=2e3b67a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b67a8",
  null
  
)

export default component.exports